module.exports = __webpack_public_path__ + "static/media/ABNB_CompTable_IPOIntelligence_a.aa9dfeb8.png";